module.exports = __webpack_public_path__ + "static/media/chevron-right.4e1f51a6.svg";